import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { type MenuItem } from "primeng/api";

export interface MenuChangeEvent {
  key: string;
  routeEvent?: boolean;
}

export interface TabCloseEvent {
  tab: MenuItem;
  index: number;
}
@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menuSource = new Subject<MenuChangeEvent>();
  private resetSource = new Subject();

  menuSource$ = this.menuSource.asObservable();
  resetSource$ = this.resetSource.asObservable();

  onMenuStateChange(event: MenuChangeEvent) {
    this.menuSource.next(event);
  }

  reset() {
    this.resetSource.next(true);
  }
}
